import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import { SET_KEYCLOAK } from './constants';

const initialState = fromJS({});

export default handleActions({
    [SET_KEYCLOAK]: (state: any, payload: any) =>  {
        return state.set('keycloak', payload.payload);
    },
}, initialState);

